import { combineReducers } from 'redux';

import marketQueryReducer from './marketQueryReducer';

const marketSearchReducer = combineReducers({
  query: marketQueryReducer,
});
export default marketSearchReducer;
